/**
 * Feature Flags
 *
 * Central configuration for toggling features on/off.
 * Change a flag to `true` to enable, `false` to disable.
 * Requires a deploy to take effect.
 */

const featureFlags = {
  drafts: false,
} as const;

export type FeatureFlag = keyof typeof featureFlags;

export const isFeatureEnabled = (flag: FeatureFlag): boolean => featureFlags[flag];
